/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './EventPage.module.scss';
import s from '../../../components/Header/Header.module.scss';
import { A, T, O, M } from 'TOMA';
import { ExhibitorRepository } from '../../../services/Exhibitor/Exhibitor.repository';
import { CodificationRepository } from '../../../services/Codification/Codification.repository';
import { EventRepository } from 'services/Event/Event.repository';
import { useParams } from 'react-router-dom';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';
import { exportPageHTML } from 'utils/htmlExport';

interface Codification {
  code: string;
  topic: string;
  topicCode: string;
  label: string;
  filter: string;
}

interface Img {
  url: string;
  width: number;
  height: number;
}

interface Exhibitor {
  id: number;
  nom_societe: string;
  raison_sociale: string;
  email_societe: string;
  site_web: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  facebook: string;
  showroom: number;
  hall: string;
  stand: string;
  adresse_postale: string;
  code_postal: string;
  ville: string;
  pays: string;
  tel_societe: string;
  type_entreprise: string;
  taille_domaine: string;
  production_annuelle: string;
  pourcentage_export: string;
  pays_export: string;
  pays_import: string;
  contact_revendeur_firstname: string;
  contact_revendeur_lastname: string;
  contact_revendeur_port: string;
  contact_revendeur_tel: string;
  contact_revendeur_email: string;
  description_en: string;
  logo: Img | null;
  galerie: Img[];
  youtube_video: string;
  showroom_logo: Img | null;
}

export default function EventPage(): JSX.Element {
  // const { setModalContent } = useModal();
  const [event, setEvent] = useState<any>(null);

  const eventRepo = new EventRepository();

  const { slug, eid: exhibitorSlug, pageSlug } = useParams();
  const [EventPage, setEventPage] = useState<any>(null);
  const [pageData, setPageData] = useState<any>(null);
  const [currentPageHtml, setCurrentPageHtml] = useState<string>('');
  const BasePath = window.location.pathname.split('/')[1];
  useEffect(() => {
    eventRepo.getPublicEventBySlug(slug ?? '').then((data) => {
      const eventData = Array.isArray(data) ? data[0] : data;
      setEvent({
        ...eventData,
        logo:
          eventData.company_logo_uuid && process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${eventData.company_logo_uuid}.${eventData.company_logo_extension}`
            : null,
      });
    });
  }, []);
  useEffect(() => {
    if (event) {
      eventRepo.getEventPage(event.id).then((data) => {
        console.log('Fetched event page data:', data);
        //setEventPage(data);
        setPageData(data.blocks);
      });
    }
  }, [event]);
  
  useEffect(() => {
    // const availablePages = Object.keys(pageData.pages);
    if (pageData && pageData.pages) {
      const pageKey = pageSlug ?? Object.keys(pageData.pages)[0];
      const html = exportPageHTML(
        pageData.pages[pageKey],
        pageData.header,
        pageKey,
        // availablePages,
        `/${BasePath}/preview/events/${slug}/pages`,
      );
      console.log('Exported HTML:', pageSlug, html);
      setCurrentPageHtml(html);
    }
  }, [pageData, pageSlug, BasePath, slug]);

  const BASE_PATH = window.location.pathname.split('/')[1];

  return (
    <>
      {event && currentPageHtml ? (
        <div dangerouslySetInnerHTML={{ __html: currentPageHtml }} />
      ) : (
        <>
          {event && (
            <div style={{ backgroundColor: event.color || '#000000' }}>
              <T.Block>
                <T.Container>
                  <T.Flex halign="space-between" py="40" gap={4}>
                    <T.Col>
                      <>
                        <T.Block my="10">
                          <A.Image
                            className="hidden"
                            src={event.logo || ''}
                            height="40"
                            width="auto"
                          />
                        </T.Block>
                        <A.Text color="white" mb="10" fontSize="24" fw="bold">
                          {event.name}
                        </A.Text>
                        <A.Text color="white" mb="10" fontSize="18">
                          {event.subtitle}
                        </A.Text>
                        <div className={s.Header__line}></div>

                        <T.Block mt="15">
                          <A.Text color="white" fontSize="18">
                            <T.Flex className="flex" gap={1}>
                              <div>
                                <A.Icon icon="calendar2-week-fill" color="white" />
                              </div>
                              <div>
                                Du {event?.date} au {event?.date_of_the_end}
                              </div>
                              <div>
                                <A.Icon icon="geo-fill" color="white" />
                              </div>
                              <div>
                                {event.city}, {event.country}
                              </div>
                            </T.Flex>
                          </A.Text>
                        </T.Block>
                      </>
                    </T.Col>
                  </T.Flex>
                </T.Container>
              </T.Block>
            </div>
          )}
          <div className={styles.Exhibitor}>
          <BreadCrumb
            breadCrumb={[
              {
                icon: null,
                href: '/' + BASE_PATH + '/preview/events',
                label: 'Events',
                isCurrent: false,
              },
              {
                icon: null,
                href: '/' + BASE_PATH + '/preview/events/' + slug + '/exhibitors',
                label: 'Exhibitors',
                isCurrent: false,
              },
            ]}
          />
          </div>
            <div data-tab="validation" style={{ textAlign: 'center', padding: '40px 20px' }}>
              {/* Validation / participation request content */}
              <T.Block my="10">
                <A.Text fontSize="16">Preview page not available</A.Text>
              </T.Block>
            </div>
        </>
      )}
    </>
  );
}
